module.exports = __webpack_public_path__ + "img/help-community.9d59265d.svg";